<template>
    <div class="file-upload">
        <a-upload :action="action" :file-list="fileLists" :before-upload="beforeUpload" :custom-request="customRequest"
            @preview="onPreview" @change="onChange" v-bind="$attrs" :accept="isPdfImg?'.pdf,.png,.jpg':''">
            <template v-if="fileLists.length < count">
                <a-button v-if="showBtn">
                    <loading-outlined v-if="loading" />
                    <upload-outlined v-else />
                    {{ names }}
                </a-button>
                <div style="margin-top:9px" v-else>暂无</div>
            </template>
        </a-upload>
    </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
import { message } from "ant-design-vue";
import { file_service } from "@/api/adminService";
import Message from "ant-design-vue/lib/message";
import axios from "axios";
// import { ls } from "@/utils/util";

export default {
    name: "FileUpload",
    emits: [
        "change",
        "update:value"
    ],
    props: {
        names: {
            type: String,
            default: '上传'
        },
        value: {
            type: String,
        },
        size: {
            type: Number,
            default: 6,
        },
        count: {
            type: Number,
            default: 1,
        },
        showBtn: {
            type: Boolean,
            default: true,
        },
        isPdfImg: {
            type: Boolean,
            default: false,
        },
        isZip: {
            type: Boolean,
            default: false,
        }
    },
    setup(props, { emit }) {
        const action = ref(file_service.upload);
        const loading = ref(false);
        const fileLists = ref([]);
        const { value } = toRefs(props);
        const fileNamevalue = ref('');

        watch(
            value,
            (value) => {
                if (value) {
                    fileLists.value = value.split(",")
                        .filter(v => v)
                        .map((v) => {
                            let vArray = v.split("|")
                            return {
                                uid: v,
                                name: vArray[1],
                                status: "done",
                                url: v,
                            };
                        });
                } else {
                    fileLists.value = [];
                }
            },
            { immediate: true }
        );
        const beforeUpload = (file) => {
            return new Promise((resolve, reject) => {
                if (file.size > props.size * 1024 * 1024) {
                    message.warning("请上传不超过" + props.size + "M的文件");
                    reject();
                }
                if (props.isPdfImg && ['application/pdf','image/png','image/jpeg'].indexOf(file.type) < 0) {
                    message.warning("请上传pdf或图片格式");
                    reject();
                }
                if (props.isZip) {
                    let str = file.name.substring(file.name.lastIndexOf(".") + 1)
                    // console.log('file', ['zip', 'rar', '7z', 'taz'].indexOf(str), str)
                    if (['zip', 'rar', '7z', 'taz'].indexOf(str) > 0) {
                        message.warning("不允许上传压缩包！");
                        reject();
                    }
                }
                resolve();
            });
        };
        const onPreview = (file) => {
            axios({
                methods: 'get',
                url: file_service.download + file.uid,
                responseType: 'blob',
                // headers: {
                //     Authorization: 'Bearer' + ls.get('token') || ''
                // }
            }).then(() => {
                // const url = window.URL.createObjectURL(
                //     new Blob([data.data], { type: "application/pdf;" })
                // );
                // window.open(url)
                // console.log('data', file_service.download + file.uid)
                // const blob = new Blob([data.data], { type: "application/vnd.ms-excel;charset=utf-8" });
                // const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + file.uid;
                link.target = '_blank';
                // console.log('link',link,url)
                // link.download = decodeURIComponent(file.name);// 文件重命名，若无需重命名，将该行删去
                link.click();
                // URL.revokeObjectURL(url); // 释放内存
            })
        };
        const onChange = ({ file, fileList }) => {
            // fileLists.value = fileList;
            switch (file.status) {
                case "uploading":
                    loading.value = true;
                    break;
                case "done":
                    loading.value = false;
                    // fileList.pop();
                    // if (file.response.code === "00000") {
                    //     fileList.push({uid: file.response.data.fid});
                    //     updateValue(fileList);
                    // } else {
                    //     message.warning(file.response.msg);
                    //     fileLists.value = fileList;
                    // }
                    break;
                case "removed":
                    loading.value = false;
                    updateValue(fileList);
                    break;
                case "error":
                    loading.value = false;
                    message.warning("上传失败");
                    // fileList.pop();
                    // fileLists.value = fileList;
                    break;
                default:
                    loading.value = false;
                    break;
            }
        };
        const customRequest = async (info) => {
            const { action, fileName, file } = info;
            let resData = await uploadFilesToServer(action, fileName, file)
            let { code = 200, data = "", msg = "ok" } = resData;
            if (code === 200) {
                updateValue([...fileLists.value, { uid: data }]);
            } else {
                Message.warn(msg);
            }
        }
        const uploadFilesToServer = (uploadApiUrl, fileName, files) => {
            let formData = new FormData();
            formData.append("file", files)
            // const headers = {
            //     Authorization: 'Bearer ' + ls.get('token') || ''
            // };
            const request = axios.create({
                // headers: headers,
            });
            return request
                .post(uploadApiUrl, formData)
                .then((response) => {
                    return Promise.resolve(response.data);
                })
                .catch((error) => {
                    Message.warn("上传失败");
                    return Promise.reject(error);
                })
                .finally(() => {
                    loading.value = false;
                });
        }
        const updateValue = (fileList = []) => {
            let value = fileList.map(item => item.uid)
                .join(',')
            emit("update:value", value);
            emit("change", value);
        };
        return {
            action,
            loading,
            fileLists,
            beforeUpload,
            onPreview,
            onChange,
            customRequest,
            fileNamevalue
        };
    },
};
</script>

<style scoped>
.file-upload {
    margin-top: -9px
}

:deep(.ant-upload-list){
    float: right;
    max-height: 80px;
    max-width:220px;
    overflow: auto;
}
</style>
